import { Icon, IconProps } from './Icon';

export type TwitterProps = IconProps;

const Twitter = (props: TwitterProps) => (
  <Icon fill="none" viewBox="0 0 23 21" {...props}>
    <path
      fill="currentColor"
      d="M17.983.263h3.457l-7.552 8.673 8.884 11.8h-6.956l-5.449-7.156-6.235 7.156H.674L8.75 11.46.229.264H7.36l4.925 6.542L17.983.263ZM16.77 18.657h1.916L6.32 2.233H4.265L16.77 18.657Z"
    />
  </Icon>
);

export { Twitter };
